export default __webpack_public_path__ + "/pdf/BrochureDigitale_ENG.pdf";